import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-308" data-mp="1lx4quf74n18t">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-309" data-mp="181sih501tc9f">
        <div className="text-center" data-id="element-310" data-mp="1c4p31195fig0">
          <h2 id="volumes-title" className="font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-311" data-mp="1c5ql3pol1578">
            What you’ll find inside the <em className="text-brand-600" data-id="element-312" data-mp="24unz3glrgfu6">CBCT Decision Map™</em>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[17px] text-muted sm:text-lg" data-id="element-313" data-mp="1qud544p5ml4s">
            6 practical volumes, each designed around a specific part of CBCT interpretation and implant planning.
          </p>
        </div>

        <div className="mt-12 divide-y divide-brand-100 border-y border-brand-100" data-id="element-314" data-mp="feyah7kf45cu">
          {volumes.map(v => <article key={v.number} className="grid gap-4 py-10 md:grid-cols-[150px_1fr] md:gap-10" data-id="element-315" data-mp="kf2h85vixlpv">
              <div className="flex items-center gap-4 md:block" data-id="element-316" data-mp="3o8yal1vp0nou">
                <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-700 font-serif text-2xl font-extrabold text-white md:h-24 md:w-24 md:text-4xl" data-id="element-317" data-mp="3j9lkm89iz0i1">
                  {v.number}
                </span>
                <p className="text-sm font-extrabold uppercase tracking-widest text-brand-600 md:mt-3" data-id="element-318" data-mp="3t6gkauhjb6xw">
                  Volume {v.number}
                </p>
              </div>
              <div data-id="element-319" data-mp="63bpw73jtzdk">
                <h3 className="font-serif text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-320" data-mp="61sb6kxjjwdw">{v.title}</h3>
                <p className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-321" data-mp="kqwqnucybmib">{v.intro}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-322" data-mp="fto8htrszih2">{v.listLabel}</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-323" data-mp="tsnxj2j89zdr">
                  {v.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-324" data-mp="pog8t5crsjfj">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-325" data-mp="wrmqfrw3uvmu">
                        <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-326" data-mp="16s6wd7ukkobe" />
                      </span>
                      {item}
                    </li>)}
                </ul>
                {v.closing && <p className="mt-5 font-serif text-lg font-bold italic text-brand-700" data-id="element-327" data-mp="1fjp9f9w7yo09">{v.closing}</p>}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-white p-6 text-center shadow-sm sm:p-10" data-id="element-328" data-mp="1pjpy7bcuxwbu">
          <p className="text-sm font-bold uppercase tracking-wider text-muted" data-id="element-329" data-mp="1ugzjcet7rltv">Your CBCT review goes from</p>
          <p className="mt-3 font-serif text-xl italic text-muted line-through decoration-alert/60 sm:text-2xl" data-id="element-330" data-mp="3rbm7sffgsw3z">
            “I think I’ve looked at everything…”
          </p>
          <p className="mt-3 text-sm font-bold uppercase tracking-wider text-muted" data-id="element-331" data-mp="2deruznw8ddaw">to</p>
          <p className="mt-3 font-serif text-2xl font-extrabold italic text-brand-700 sm:text-3xl" data-id="element-332" data-mp="28mru9t8c6gd9">
            “I’ve followed the complete review sequence.”
          </p>
        </div>

        <CtaButton className="mt-12" label="I want all 6 volumes today" data-id="element-333" data-mp="1zmv7xy9f5tld" />
      </div>
    </section>;
}